import { render, staticRenderFns } from "./ViewAffiliates.vue?vue&type=template&id=8ddd0ae6&scoped=true"
import script from "./ViewAffiliates.vue?vue&type=script&lang=js"
export * from "./ViewAffiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddd0ae6",
  null
  
)

export default component.exports